export class PastIllness {
  end_date?: string;
  dt?: string;
  onset_date?: string;
  firstname?: string;
  code?: string;
  coding_id?: number;
  patient_id?: number;
  description?: string;
  version_id?: number;
  resolution_circumstances?: string;
  status?: number;
  lastname?: string;
  [key: string]: any;
}
